import { TreatAllergy } from '@uplift/types';
import { restClient } from '../../client';

export type GetTreatAllergiesResponse = {
  data: TreatAllergy[];
};

export const getTreatAllergies = (allergyName: string) =>
  restClient.request<GetTreatAllergiesResponse>(`/vendor/treat/allergies?allergy_name=${allergyName}`);